module.exports = __webpack_public_path__ + "static/media/loginbg.495f54d6.svg";